import { config } from '@abyss/ui/tools/config';
import { getFeature } from '../features';

export const injectAuthScript = () => {
  if (!document.getElementById('uhc-ohid-script')) {
    const script = document.createElement('script');
    script.src = getFeature('OHID_SESSION_REWORK')
      ? config('UHC_OHID_URL_V2')
      : config('UHC_OHID_URL');
    script.id = 'uhc-ohid-script';
    document.head.appendChild(script);
  }
};
